export default [
  {
    id: 376132662,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzYxMzI2NjI=',
    name: 'ac-library',
    full_name: 'SirZeck/ac-library',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/ac-library',
    description: 'AtCoder Library',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/ac-library',
    forks_url: 'https://api.github.com/repos/SirZeck/ac-library/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/ac-library/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/ac-library/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/ac-library/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/ac-library/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/ac-library/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/ac-library/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/ac-library/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/ac-library/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/ac-library/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/ac-library/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/ac-library/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/ac-library/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/ac-library/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/ac-library/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/ac-library/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/ac-library/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/ac-library/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/ac-library/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/ac-library/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/ac-library/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/ac-library/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/ac-library/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/ac-library/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/ac-library/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/ac-library/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/ac-library/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/ac-library/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/ac-library/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/ac-library/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/ac-library/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/ac-library/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/ac-library/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/ac-library/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/ac-library/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/ac-library/deployments',
    created_at: '2021-06-11T20:11:32Z',
    updated_at: '2021-06-11T20:11:33Z',
    pushed_at: '2021-03-27T10:08:17Z',
    git_url: 'git://github.com/SirZeck/ac-library.git',
    ssh_url: 'git@github.com:SirZeck/ac-library.git',
    clone_url: 'https://github.com/SirZeck/ac-library.git',
    svn_url: 'https://github.com/SirZeck/ac-library',
    homepage: '',
    size: 918,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 376107003,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzYxMDcwMDM=',
    name: 'algo',
    full_name: 'SirZeck/algo',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/algo',
    description: null,
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/algo',
    forks_url: 'https://api.github.com/repos/SirZeck/algo/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/algo/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/algo/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/algo/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/algo/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/algo/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/algo/events',
    assignees_url: 'https://api.github.com/repos/SirZeck/algo/assignees{/user}',
    branches_url: 'https://api.github.com/repos/SirZeck/algo/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/algo/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/algo/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/SirZeck/algo/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/SirZeck/algo/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/algo/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/SirZeck/algo/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/algo/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/algo/stargazers',
    contributors_url: 'https://api.github.com/repos/SirZeck/algo/contributors',
    subscribers_url: 'https://api.github.com/repos/SirZeck/algo/subscribers',
    subscription_url: 'https://api.github.com/repos/SirZeck/algo/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/algo/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/algo/git/commits{/sha}',
    comments_url: 'https://api.github.com/repos/SirZeck/algo/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/algo/issues/comments{/number}',
    contents_url: 'https://api.github.com/repos/SirZeck/algo/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/algo/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/algo/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/algo/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/algo/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/algo/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/algo/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/algo/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/algo/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/algo/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/algo/releases{/id}',
    deployments_url: 'https://api.github.com/repos/SirZeck/algo/deployments',
    created_at: '2021-06-11T18:09:19Z',
    updated_at: '2021-06-11T18:09:20Z',
    pushed_at: '2019-02-08T15:52:29Z',
    git_url: 'git://github.com/SirZeck/algo.git',
    ssh_url: 'git@github.com:SirZeck/algo.git',
    clone_url: 'https://github.com/SirZeck/algo.git',
    svn_url: 'https://github.com/SirZeck/algo',
    homepage: null,
    size: 96,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 384898154,
    node_id: 'MDEwOlJlcG9zaXRvcnkzODQ4OTgxNTQ=',
    name: 'algo-lib',
    full_name: 'SirZeck/algo-lib',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/algo-lib',
    description:
      'Concise, performant data structures and algorithms in C++ (mostly authored by saketh-are).',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/algo-lib',
    forks_url: 'https://api.github.com/repos/SirZeck/algo-lib/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/algo-lib/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/algo-lib/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/algo-lib/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/algo-lib/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/algo-lib/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/algo-lib/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/algo-lib/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/algo-lib/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/algo-lib/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/algo-lib/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/algo-lib/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/algo-lib/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/algo-lib/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/algo-lib/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/algo-lib/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/algo-lib/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/algo-lib/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/algo-lib/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/algo-lib/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/algo-lib/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/algo-lib/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/algo-lib/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/algo-lib/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/algo-lib/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/algo-lib/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/algo-lib/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/algo-lib/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/algo-lib/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/algo-lib/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/algo-lib/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/algo-lib/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/algo-lib/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/algo-lib/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/algo-lib/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/algo-lib/deployments',
    created_at: '2021-07-11T08:38:46Z',
    updated_at: '2021-09-04T01:50:47Z',
    pushed_at: '2021-06-21T22:45:20Z',
    git_url: 'git://github.com/SirZeck/algo-lib.git',
    ssh_url: 'git@github.com:SirZeck/algo-lib.git',
    clone_url: 'https://github.com/SirZeck/algo-lib.git',
    svn_url: 'https://github.com/SirZeck/algo-lib',
    homepage: '',
    size: 358,
    stargazers_count: 1,
    watchers_count: 1,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: 'master',
  },
  {
    id: 397546210,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTc1NDYyMTA=',
    name: 'algorithm-visualizer',
    full_name: 'SirZeck/algorithm-visualizer',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/algorithm-visualizer',
    description:
      ':fireworks:Interactive Online Platform that Visualizes Algorithms from Code',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/algorithm-visualizer',
    forks_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/algorithm-visualizer/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/algorithm-visualizer/deployments',
    created_at: '2021-08-18T09:34:51Z',
    updated_at: '2021-08-18T09:34:52Z',
    pushed_at: '2021-08-10T20:51:16Z',
    git_url: 'git://github.com/SirZeck/algorithm-visualizer.git',
    ssh_url: 'git@github.com:SirZeck/algorithm-visualizer.git',
    clone_url: 'https://github.com/SirZeck/algorithm-visualizer.git',
    svn_url: 'https://github.com/SirZeck/algorithm-visualizer',
    homepage: 'https://algorithm-visualizer.org/',
    size: 22530,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 397679717,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTc2Nzk3MTc=',
    name: 'Algorithms',
    full_name: 'SirZeck/Algorithms',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Algorithms',
    description: 'A collection of algorithms and data structures',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/Algorithms',
    forks_url: 'https://api.github.com/repos/SirZeck/Algorithms/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/Algorithms/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Algorithms/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Algorithms/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Algorithms/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Algorithms/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/Algorithms/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Algorithms/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Algorithms/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Algorithms/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Algorithms/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Algorithms/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Algorithms/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Algorithms/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Algorithms/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/Algorithms/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Algorithms/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Algorithms/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Algorithms/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Algorithms/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Algorithms/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Algorithms/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Algorithms/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Algorithms/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Algorithms/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Algorithms/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/Algorithms/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Algorithms/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/Algorithms/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Algorithms/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/Algorithms/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Algorithms/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Algorithms/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/Algorithms/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Algorithms/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Algorithms/deployments',
    created_at: '2021-08-18T17:14:02Z',
    updated_at: '2021-08-18T17:14:04Z',
    pushed_at: '2021-08-14T18:40:53Z',
    git_url: 'git://github.com/SirZeck/Algorithms.git',
    ssh_url: 'git@github.com:SirZeck/Algorithms.git',
    clone_url: 'https://github.com/SirZeck/Algorithms.git',
    svn_url: 'https://github.com/SirZeck/Algorithms',
    homepage: '',
    size: 1030515,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 395680196,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTU2ODAxOTY=',
    name: 'assessment-repo',
    full_name: 'SirZeck/assessment-repo',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/assessment-repo',
    description: 'Assessment repo for Walkover Training Program.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/assessment-repo',
    forks_url: 'https://api.github.com/repos/SirZeck/assessment-repo/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/assessment-repo/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/assessment-repo/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/assessment-repo/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/assessment-repo/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/assessment-repo/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/assessment-repo/deployments',
    created_at: '2021-08-13T14:16:30Z',
    updated_at: '2021-08-14T04:41:28Z',
    pushed_at: '2021-08-14T04:41:25Z',
    git_url: 'git://github.com/SirZeck/assessment-repo.git',
    ssh_url: 'git@github.com:SirZeck/assessment-repo.git',
    clone_url: 'https://github.com/SirZeck/assessment-repo.git',
    svn_url: 'https://github.com/SirZeck/assessment-repo',
    homepage: 'https://sirzeck.github.io/assessment-repo/',
    size: 9,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 411347825,
    node_id: 'R_kgDOGISrcQ',
    name: 'Auth-Template',
    full_name: 'SirZeck/Auth-Template',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Auth-Template',
    description: 'A GDrive-clone built with React and Firebase.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Auth-Template',
    forks_url: 'https://api.github.com/repos/SirZeck/Auth-Template/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Auth-Template/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Auth-Template/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/Auth-Template/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Auth-Template/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/Auth-Template/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Auth-Template/deployments',
    created_at: '2021-09-28T15:56:08Z',
    updated_at: '2021-09-30T11:20:00Z',
    pushed_at: '2021-09-28T15:56:09Z',
    git_url: 'git://github.com/SirZeck/Auth-Template.git',
    ssh_url: 'git@github.com:SirZeck/Auth-Template.git',
    clone_url: 'https://github.com/SirZeck/Auth-Template.git',
    svn_url: 'https://github.com/SirZeck/Auth-Template',
    homepage: null,
    size: 23,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 394850183,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTQ4NTAxODM=',
    name: 'Awesome-CV',
    full_name: 'SirZeck/Awesome-CV',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Awesome-CV',
    description:
      ':page_facing_up: Awesome CV is LaTeX template for your outstanding job application',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/Awesome-CV',
    forks_url: 'https://api.github.com/repos/SirZeck/Awesome-CV/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/Awesome-CV/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Awesome-CV/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Awesome-CV/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/Awesome-CV/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Awesome-CV/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/Awesome-CV/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/Awesome-CV/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/Awesome-CV/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/Awesome-CV/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/Awesome-CV/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Awesome-CV/deployments',
    created_at: '2021-08-11T03:29:20Z',
    updated_at: '2021-08-11T03:29:21Z',
    pushed_at: '2021-07-14T03:49:21Z',
    git_url: 'git://github.com/SirZeck/Awesome-CV.git',
    ssh_url: 'git@github.com:SirZeck/Awesome-CV.git',
    clone_url: 'https://github.com/SirZeck/Awesome-CV.git',
    svn_url: 'https://github.com/SirZeck/Awesome-CV',
    homepage: '',
    size: 15851,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 418588216,
    node_id: 'R_kgDOGPMmOA',
    name: 'Chuck-Norris-Jokes',
    full_name: 'SirZeck/Chuck-Norris-Jokes',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Chuck-Norris-Jokes',
    description: 'Pause a moment and read some jokes fired by Chuck!!',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes',
    forks_url: 'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Chuck-Norris-Jokes/deployments',
    created_at: '2021-10-18T16:46:06Z',
    updated_at: '2021-10-18T16:55:49Z',
    pushed_at: '2021-10-18T16:48:14Z',
    git_url: 'git://github.com/SirZeck/Chuck-Norris-Jokes.git',
    ssh_url: 'git@github.com:SirZeck/Chuck-Norris-Jokes.git',
    clone_url: 'https://github.com/SirZeck/Chuck-Norris-Jokes.git',
    svn_url: 'https://github.com/SirZeck/Chuck-Norris-Jokes',
    homepage: 'https://sirzeck.github.io/Chuck-Norris-Jokes/',
    size: 63,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['ajax', 'javascript', 'jokes-api'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 418591040,
    node_id: 'R_kgDOGPMxQA',
    name: 'Cocktail-Menu',
    full_name: 'SirZeck/Cocktail-Menu',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Cocktail-Menu',
    description: 'A pocket menu for the cocktails.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Cocktail-Menu',
    forks_url: 'https://api.github.com/repos/SirZeck/Cocktail-Menu/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Cocktail-Menu/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Cocktail-Menu/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/Cocktail-Menu/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Cocktail-Menu/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/Cocktail-Menu/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Cocktail-Menu/deployments',
    created_at: '2021-10-18T16:54:26Z',
    updated_at: '2021-10-31T09:36:59Z',
    pushed_at: '2021-10-31T09:36:56Z',
    git_url: 'git://github.com/SirZeck/Cocktail-Menu.git',
    ssh_url: 'git@github.com:SirZeck/Cocktail-Menu.git',
    clone_url: 'https://github.com/SirZeck/Cocktail-Menu.git',
    svn_url: 'https://github.com/SirZeck/Cocktail-Menu',
    homepage: 'https://sirzeck.github.io/Cocktail-Menu/',
    size: 584,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['ajax', 'cocktail-db', 'javascript'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 423102626,
    node_id: 'R_kgDOGTgIog',
    name: 'Cocktails-List',
    full_name: 'SirZeck/Cocktails-List',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Cocktails-List',
    description: 'A cocktails list app to search for your favorite drink.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Cocktails-List',
    forks_url: 'https://api.github.com/repos/SirZeck/Cocktails-List/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Cocktails-List/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Cocktails-List/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/Cocktails-List/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Cocktails-List/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/Cocktails-List/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Cocktails-List/deployments',
    created_at: '2021-10-31T09:21:04Z',
    updated_at: '2021-10-31T09:32:47Z',
    pushed_at: '2021-10-31T09:30:44Z',
    git_url: 'git://github.com/SirZeck/Cocktails-List.git',
    ssh_url: 'git@github.com:SirZeck/Cocktails-List.git',
    clone_url: 'https://github.com/SirZeck/Cocktails-List.git',
    svn_url: 'https://github.com/SirZeck/Cocktails-List',
    homepage: 'https://your-cocktails-list.netlify.app/',
    size: 178,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['cocktails-api', 'react'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 375258862,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzUyNTg4NjI=',
    name: 'Code-Library-Of-Others',
    full_name: 'SirZeck/Code-Library-Of-Others',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Code-Library-Of-Others',
    description: null,
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/Code-Library-Of-Others',
    forks_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Code-Library-Of-Others/deployments',
    created_at: '2021-06-09T07:03:55Z',
    updated_at: '2021-06-09T07:03:56Z',
    pushed_at: '2019-01-03T04:26:47Z',
    git_url: 'git://github.com/SirZeck/Code-Library-Of-Others.git',
    ssh_url: 'git@github.com:SirZeck/Code-Library-Of-Others.git',
    clone_url: 'https://github.com/SirZeck/Code-Library-Of-Others.git',
    svn_url: 'https://github.com/SirZeck/Code-Library-Of-Others',
    homepage: null,
    size: 702,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 390608409,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTA2MDg0MDk=',
    name: 'coding-interview-university',
    full_name: 'SirZeck/coding-interview-university',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/coding-interview-university',
    description:
      'A complete computer science study plan to become a software engineer.',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/coding-interview-university',
    forks_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/coding-interview-university/deployments',
    created_at: '2021-07-29T05:16:36Z',
    updated_at: '2021-07-29T05:16:37Z',
    pushed_at: '2021-07-29T00:16:11Z',
    git_url: 'git://github.com/SirZeck/coding-interview-university.git',
    ssh_url: 'git@github.com:SirZeck/coding-interview-university.git',
    clone_url: 'https://github.com/SirZeck/coding-interview-university.git',
    svn_url: 'https://github.com/SirZeck/coding-interview-university',
    homepage: '',
    size: 14471,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'cc-by-sa-4.0',
      name: 'Creative Commons Attribution Share Alike 4.0 International',
      spdx_id: 'CC-BY-SA-4.0',
      url: 'https://api.github.com/licenses/cc-by-sa-4.0',
      node_id: 'MDc6TGljZW5zZTI2',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 1,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 421706324,
    node_id: 'R_kgDOGSK6VA',
    name: 'Color-Generator',
    full_name: 'SirZeck/Color-Generator',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Color-Generator',
    description: 'A color generator app',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Color-Generator',
    forks_url: 'https://api.github.com/repos/SirZeck/Color-Generator/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Color-Generator/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Color-Generator/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/Color-Generator/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Color-Generator/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/Color-Generator/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Color-Generator/deployments',
    created_at: '2021-10-27T06:45:40Z',
    updated_at: '2021-10-27T07:05:31Z',
    pushed_at: '2021-10-27T07:04:05Z',
    git_url: 'git://github.com/SirZeck/Color-Generator.git',
    ssh_url: 'git@github.com:SirZeck/Color-Generator.git',
    clone_url: 'https://github.com/SirZeck/Color-Generator.git',
    svn_url: 'https://github.com/SirZeck/Color-Generator',
    homepage: 'https://generate-your-color.netlify.app/',
    size: 169,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['color-palette', 'react'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 418948489,
    node_id: 'R_kgDOGPiliQ',
    name: 'Comfy-Store',
    full_name: 'SirZeck/Comfy-Store',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Comfy-Store',
    description: 'An E-Commerce Furniture Website using Vanilla-JS',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Comfy-Store',
    forks_url: 'https://api.github.com/repos/SirZeck/Comfy-Store/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/Comfy-Store/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Comfy-Store/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Comfy-Store/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/Comfy-Store/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Comfy-Store/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/Comfy-Store/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/Comfy-Store/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/Comfy-Store/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Comfy-Store/deployments',
    created_at: '2021-10-19T13:59:50Z',
    updated_at: '2021-10-22T09:27:23Z',
    pushed_at: '2021-10-22T09:27:21Z',
    git_url: 'git://github.com/SirZeck/Comfy-Store.git',
    ssh_url: 'git@github.com:SirZeck/Comfy-Store.git',
    clone_url: 'https://github.com/SirZeck/Comfy-Store.git',
    svn_url: 'https://github.com/SirZeck/Comfy-Store',
    homepage: 'https://your-comfy-store.netlify.app/',
    size: 111,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['e-commerce-project', 'javascript'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 412372649,
    node_id: 'R_kgDOGJROqQ',
    name: 'computer-science',
    full_name: 'SirZeck/computer-science',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/computer-science',
    description:
      ':mortar_board: Path to a free self-taught education in Computer Science!',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/computer-science',
    forks_url: 'https://api.github.com/repos/SirZeck/computer-science/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/computer-science/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/computer-science/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/computer-science/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/computer-science/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/computer-science/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/computer-science/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/computer-science/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/computer-science/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/computer-science/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/computer-science/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/computer-science/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/computer-science/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/computer-science/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/computer-science/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/computer-science/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/computer-science/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/computer-science/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/computer-science/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/computer-science/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/computer-science/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/computer-science/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/computer-science/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/computer-science/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/computer-science/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/computer-science/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/computer-science/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/computer-science/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/computer-science/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/computer-science/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/computer-science/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/computer-science/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/computer-science/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/computer-science/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/computer-science/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/computer-science/deployments',
    created_at: '2021-10-01T07:33:57Z',
    updated_at: '2021-10-10T07:30:14Z',
    pushed_at: '2021-09-16T02:43:11Z',
    git_url: 'git://github.com/SirZeck/computer-science.git',
    ssh_url: 'git@github.com:SirZeck/computer-science.git',
    clone_url: 'https://github.com/SirZeck/computer-science.git',
    svn_url: 'https://github.com/SirZeck/computer-science',
    homepage: '',
    size: 1066,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 375134245,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzUxMzQyNDU=',
    name: 'contest_library',
    full_name: 'SirZeck/contest_library',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/contest_library',
    description: 'A library to use at online programmming contests',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/contest_library',
    forks_url: 'https://api.github.com/repos/SirZeck/contest_library/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/contest_library/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/contest_library/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/contest_library/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/contest_library/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/contest_library/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/contest_library/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/contest_library/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/contest_library/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/contest_library/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/contest_library/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/contest_library/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/contest_library/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/contest_library/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/contest_library/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/contest_library/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/contest_library/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/contest_library/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/contest_library/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/contest_library/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/contest_library/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/contest_library/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/contest_library/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/contest_library/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/contest_library/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/contest_library/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/contest_library/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/contest_library/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/contest_library/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/contest_library/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/contest_library/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/contest_library/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/contest_library/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/contest_library/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/contest_library/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/contest_library/deployments',
    created_at: '2021-06-08T20:18:34Z',
    updated_at: '2021-06-08T20:18:35Z',
    pushed_at: '2020-10-01T09:19:11Z',
    git_url: 'git://github.com/SirZeck/contest_library.git',
    ssh_url: 'git@github.com:SirZeck/contest_library.git',
    clone_url: 'https://github.com/SirZeck/contest_library.git',
    svn_url: 'https://github.com/SirZeck/contest_library',
    homepage: null,
    size: 272,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 390457206,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTA0NTcyMDY=',
    name: 'CP-CF',
    full_name: 'SirZeck/CP-CF',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/CP-CF',
    description: 'My repo of practice problems and contest problems',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/CP-CF',
    forks_url: 'https://api.github.com/repos/SirZeck/CP-CF/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/CP-CF/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/CP-CF/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/CP-CF/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/CP-CF/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/CP-CF/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/CP-CF/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/CP-CF/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/CP-CF/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/CP-CF/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/CP-CF/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/SirZeck/CP-CF/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/SirZeck/CP-CF/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/CP-CF/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/SirZeck/CP-CF/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/CP-CF/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/CP-CF/stargazers',
    contributors_url: 'https://api.github.com/repos/SirZeck/CP-CF/contributors',
    subscribers_url: 'https://api.github.com/repos/SirZeck/CP-CF/subscribers',
    subscription_url: 'https://api.github.com/repos/SirZeck/CP-CF/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/CP-CF/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/CP-CF/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/CP-CF/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/CP-CF/issues/comments{/number}',
    contents_url: 'https://api.github.com/repos/SirZeck/CP-CF/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/CP-CF/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/CP-CF/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/CP-CF/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/CP-CF/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/CP-CF/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/CP-CF/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/CP-CF/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/CP-CF/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/CP-CF/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/CP-CF/releases{/id}',
    deployments_url: 'https://api.github.com/repos/SirZeck/CP-CF/deployments',
    created_at: '2021-07-28T18:15:22Z',
    updated_at: '2021-09-26T17:43:03Z',
    pushed_at: '2021-09-26T17:42:58Z',
    git_url: 'git://github.com/SirZeck/CP-CF.git',
    ssh_url: 'git@github.com:SirZeck/CP-CF.git',
    clone_url: 'https://github.com/SirZeck/CP-CF.git',
    svn_url: 'https://github.com/SirZeck/CP-CF',
    homepage: null,
    size: 5111,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 394536929,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTQ1MzY5Mjk=',
    name: 'CP-Guide',
    full_name: 'SirZeck/CP-Guide',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/CP-Guide',
    description: 'Guide to your start of CP journey.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/CP-Guide',
    forks_url: 'https://api.github.com/repos/SirZeck/CP-Guide/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/CP-Guide/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/CP-Guide/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/CP-Guide/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/CP-Guide/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/CP-Guide/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/CP-Guide/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/CP-Guide/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/CP-Guide/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/CP-Guide/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/CP-Guide/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/CP-Guide/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/CP-Guide/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/CP-Guide/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/CP-Guide/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/CP-Guide/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/CP-Guide/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/CP-Guide/deployments',
    created_at: '2021-08-10T05:35:16Z',
    updated_at: '2021-08-26T10:21:23Z',
    pushed_at: '2021-08-13T15:49:42Z',
    git_url: 'git://github.com/SirZeck/CP-Guide.git',
    ssh_url: 'git@github.com:SirZeck/CP-Guide.git',
    clone_url: 'https://github.com/SirZeck/CP-Guide.git',
    svn_url: 'https://github.com/SirZeck/CP-Guide',
    homepage: 'https://sirzeck.github.io/CP-Guide/',
    size: 8887,
    stargazers_count: 1,
    watchers_count: 1,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: 'main',
  },
  {
    id: 403924531,
    node_id: 'MDEwOlJlcG9zaXRvcnk0MDM5MjQ1MzE=',
    name: 'delusionaloptimist.github.io',
    full_name: 'SirZeck/delusionaloptimist.github.io',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/delusionaloptimist.github.io',
    description: 'https://delusionaloptimist.github.io',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io',
    forks_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/delusionaloptimist.github.io/deployments',
    created_at: '2021-09-07T09:47:24Z',
    updated_at: '2021-09-07T09:47:25Z',
    pushed_at: '2021-08-16T07:41:14Z',
    git_url: 'git://github.com/SirZeck/delusionaloptimist.github.io.git',
    ssh_url: 'git@github.com:SirZeck/delusionaloptimist.github.io.git',
    clone_url: 'https://github.com/SirZeck/delusionaloptimist.github.io.git',
    svn_url: 'https://github.com/SirZeck/delusionaloptimist.github.io',
    homepage: 'https://delusionaloptimist.github.io',
    size: 338,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 404347936,
    node_id: 'MDEwOlJlcG9zaXRvcnk0MDQzNDc5MzY=',
    name: 'devopschatrooms',
    full_name: 'SirZeck/devopschatrooms',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/devopschatrooms',
    description:
      'Top 100 active Slack or Discord workspaces for DevOps Engineers',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/devopschatrooms',
    forks_url: 'https://api.github.com/repos/SirZeck/devopschatrooms/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/devopschatrooms/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/devopschatrooms/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/devopschatrooms/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/devopschatrooms/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/devopschatrooms/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/devopschatrooms/deployments',
    created_at: '2021-09-08T12:57:02Z',
    updated_at: '2021-09-08T13:09:24Z',
    pushed_at: '2021-09-08T13:09:21Z',
    git_url: 'git://github.com/SirZeck/devopschatrooms.git',
    ssh_url: 'git@github.com:SirZeck/devopschatrooms.git',
    clone_url: 'https://github.com/SirZeck/devopschatrooms.git',
    svn_url: 'https://github.com/SirZeck/devopschatrooms',
    homepage: '',
    size: 986,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 390221832,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTAyMjE4MzI=',
    name: 'established-remote',
    full_name: 'SirZeck/established-remote',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/established-remote',
    description: 'A list of established remote companies',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/established-remote',
    forks_url: 'https://api.github.com/repos/SirZeck/established-remote/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/established-remote/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/established-remote/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/established-remote/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/established-remote/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/established-remote/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/established-remote/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/established-remote/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/established-remote/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/established-remote/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/established-remote/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/established-remote/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/established-remote/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/established-remote/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/established-remote/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/established-remote/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/established-remote/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/established-remote/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/established-remote/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/established-remote/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/established-remote/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/established-remote/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/established-remote/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/established-remote/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/established-remote/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/established-remote/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/established-remote/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/established-remote/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/established-remote/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/established-remote/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/established-remote/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/established-remote/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/established-remote/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/established-remote/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/established-remote/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/established-remote/deployments',
    created_at: '2021-07-28T05:11:38Z',
    updated_at: '2021-09-27T17:25:32Z',
    pushed_at: '2021-09-27T17:25:29Z',
    git_url: 'git://github.com/SirZeck/established-remote.git',
    ssh_url: 'git@github.com:SirZeck/established-remote.git',
    clone_url: 'https://github.com/SirZeck/established-remote.git',
    svn_url: 'https://github.com/SirZeck/established-remote',
    homepage: null,
    size: 235,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 375651674,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzU2NTE2NzQ=',
    name: 'Free-Algorithm-Books',
    full_name: 'SirZeck/Free-Algorithm-Books',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Free-Algorithm-Books',
    description: null,
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/Free-Algorithm-Books',
    forks_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Free-Algorithm-Books/deployments',
    created_at: '2021-06-10T10:01:36Z',
    updated_at: '2021-09-22T21:59:25Z',
    pushed_at: '2021-01-27T18:38:12Z',
    git_url: 'git://github.com/SirZeck/Free-Algorithm-Books.git',
    ssh_url: 'git@github.com:SirZeck/Free-Algorithm-Books.git',
    clone_url: 'https://github.com/SirZeck/Free-Algorithm-Books.git',
    svn_url: 'https://github.com/SirZeck/Free-Algorithm-Books',
    homepage: null,
    size: 215348,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 410959304,
    node_id: 'R_kgDOGH69yA',
    name: 'gg-drive',
    full_name: 'SirZeck/gg-drive',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/gg-drive',
    description: 'A minimalistic drive to store your files. GG.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/gg-drive',
    forks_url: 'https://api.github.com/repos/SirZeck/gg-drive/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/gg-drive/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/gg-drive/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/gg-drive/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/gg-drive/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/gg-drive/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/gg-drive/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/gg-drive/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/gg-drive/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/gg-drive/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/gg-drive/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/gg-drive/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/gg-drive/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/gg-drive/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/gg-drive/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/gg-drive/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/gg-drive/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/gg-drive/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/gg-drive/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/gg-drive/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/gg-drive/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/gg-drive/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/gg-drive/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/gg-drive/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/gg-drive/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/gg-drive/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/gg-drive/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/gg-drive/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/gg-drive/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/gg-drive/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/gg-drive/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/gg-drive/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/gg-drive/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/gg-drive/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/gg-drive/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/gg-drive/deployments',
    created_at: '2021-09-27T16:24:09Z',
    updated_at: '2021-10-02T10:44:07Z',
    pushed_at: '2021-09-30T05:01:50Z',
    git_url: 'git://github.com/SirZeck/gg-drive.git',
    ssh_url: 'git@github.com:SirZeck/gg-drive.git',
    clone_url: 'https://github.com/SirZeck/gg-drive.git',
    svn_url: 'https://github.com/SirZeck/gg-drive',
    homepage: 'https://gg-drive.netlify.app/',
    size: 776,
    stargazers_count: 1,
    watchers_count: 1,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['authentication', 'drive', 'firebase', 'react'],
    visibility: 'public',
    forks: 0,
    open_issues: 1,
    watchers: 1,
    default_branch: 'main',
  },
  {
    id: 416632479,
    node_id: 'R_kgDOGNVOnw',
    name: 'Grocery-Bud',
    full_name: 'SirZeck/Grocery-Bud',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Grocery-Bud',
    description: 'A web app to store your grocery list.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Grocery-Bud',
    forks_url: 'https://api.github.com/repos/SirZeck/Grocery-Bud/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/Grocery-Bud/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Grocery-Bud/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Grocery-Bud/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/Grocery-Bud/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Grocery-Bud/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/Grocery-Bud/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/Grocery-Bud/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/Grocery-Bud/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud/deployments',
    created_at: '2021-10-13T07:26:10Z',
    updated_at: '2021-10-27T10:36:35Z',
    pushed_at: '2021-10-27T10:35:08Z',
    git_url: 'git://github.com/SirZeck/Grocery-Bud.git',
    ssh_url: 'git@github.com:SirZeck/Grocery-Bud.git',
    clone_url: 'https://github.com/SirZeck/Grocery-Bud.git',
    svn_url: 'https://github.com/SirZeck/Grocery-Bud',
    homepage: 'https://sirzeck.github.io/Grocery-Bud/',
    size: 11,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['crud-application', 'javascript'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 421769516,
    node_id: 'R_kgDOGSOxLA',
    name: 'Grocery-Bud-React-App',
    full_name: 'SirZeck/Grocery-Bud-React-App',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Grocery-Bud-React-App',
    description: 'A web app to store your grocery list using React.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App',
    forks_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Grocery-Bud-React-App/deployments',
    created_at: '2021-10-27T10:14:56Z',
    updated_at: '2021-10-27T10:34:30Z',
    pushed_at: '2021-10-27T10:34:27Z',
    git_url: 'git://github.com/SirZeck/Grocery-Bud-React-App.git',
    ssh_url: 'git@github.com:SirZeck/Grocery-Bud-React-App.git',
    clone_url: 'https://github.com/SirZeck/Grocery-Bud-React-App.git',
    svn_url: 'https://github.com/SirZeck/Grocery-Bud-React-App',
    homepage: 'https://your-grocery-bud.netlify.app/',
    size: 171,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['crud-application', 'react'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 424121942,
    node_id: 'R_kgDOGUeWVg',
    name: 'Hacker-News-Search',
    full_name: 'SirZeck/Hacker-News-Search',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Hacker-News-Search',
    description: 'A hacker news search app to stay updated with tech and news.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Hacker-News-Search',
    forks_url: 'https://api.github.com/repos/SirZeck/Hacker-News-Search/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Hacker-News-Search/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Hacker-News-Search/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Hacker-News-Search/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Hacker-News-Search/deployments',
    created_at: '2021-11-03T07:00:35Z',
    updated_at: '2021-11-03T07:08:29Z',
    pushed_at: '2021-11-03T07:04:40Z',
    git_url: 'git://github.com/SirZeck/Hacker-News-Search.git',
    ssh_url: 'git@github.com:SirZeck/Hacker-News-Search.git',
    clone_url: 'https://github.com/SirZeck/Hacker-News-Search.git',
    svn_url: 'https://github.com/SirZeck/Hacker-News-Search',
    homepage: 'https://search-hecker-news.netlify.app/',
    size: 170,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['hacker-news-api', 'react'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 196177712,
    node_id: 'MDEwOlJlcG9zaXRvcnkxOTYxNzc3MTI=',
    name: 'Hello-World',
    full_name: 'SirZeck/Hello-World',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Hello-World',
    description: 'Just Getting Started',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Hello-World',
    forks_url: 'https://api.github.com/repos/SirZeck/Hello-World/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/Hello-World/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Hello-World/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Hello-World/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Hello-World/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Hello-World/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/Hello-World/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Hello-World/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Hello-World/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Hello-World/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Hello-World/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Hello-World/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Hello-World/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Hello-World/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Hello-World/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/Hello-World/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Hello-World/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Hello-World/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Hello-World/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Hello-World/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Hello-World/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Hello-World/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Hello-World/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Hello-World/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Hello-World/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Hello-World/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/Hello-World/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Hello-World/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/Hello-World/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Hello-World/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Hello-World/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Hello-World/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Hello-World/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Hello-World/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Hello-World/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Hello-World/deployments',
    created_at: '2019-07-10T09:40:39Z',
    updated_at: '2019-07-10T09:51:30Z',
    pushed_at: '2019-07-10T09:51:33Z',
    git_url: 'git://github.com/SirZeck/Hello-World.git',
    ssh_url: 'git@github.com:SirZeck/Hello-World.git',
    clone_url: 'https://github.com/SirZeck/Hello-World.git',
    svn_url: 'https://github.com/SirZeck/Hello-World',
    homepage: null,
    size: 1,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 1,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 397878270,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTc4NzgyNzA=',
    name: 'intro-to-apis-course',
    full_name: 'SirZeck/intro-to-apis-course',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/intro-to-apis-course',
    description: 'Introduction to APIs course',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/intro-to-apis-course',
    forks_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/intro-to-apis-course/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/intro-to-apis-course/deployments',
    created_at: '2021-08-19T08:54:04Z',
    updated_at: '2021-08-19T08:54:05Z',
    pushed_at: '2021-04-16T23:01:47Z',
    git_url: 'git://github.com/SirZeck/intro-to-apis-course.git',
    ssh_url: 'git@github.com:SirZeck/intro-to-apis-course.git',
    clone_url: 'https://github.com/SirZeck/intro-to-apis-course.git',
    svn_url: 'https://github.com/SirZeck/intro-to-apis-course',
    homepage: '',
    size: 50,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 397878150,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTc4NzgxNTA=',
    name: 'introduction-to-postman-course',
    full_name: 'SirZeck/introduction-to-postman-course',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/introduction-to-postman-course',
    description: null,
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/introduction-to-postman-course',
    forks_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/introduction-to-postman-course/deployments',
    created_at: '2021-08-19T08:53:34Z',
    updated_at: '2021-08-19T08:53:35Z',
    pushed_at: '2021-04-04T09:28:33Z',
    git_url: 'git://github.com/SirZeck/introduction-to-postman-course.git',
    ssh_url: 'git@github.com:SirZeck/introduction-to-postman-course.git',
    clone_url: 'https://github.com/SirZeck/introduction-to-postman-course.git',
    svn_url: 'https://github.com/SirZeck/introduction-to-postman-course',
    homepage: null,
    size: 33,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 418457088,
    node_id: 'R_kgDOGPEmAA',
    name: 'javascript-basic-ajax-project',
    full_name: 'SirZeck/javascript-basic-ajax-project',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/javascript-basic-ajax-project',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project',
    forks_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-ajax-project/deployments',
    created_at: '2021-10-18T10:47:34Z',
    updated_at: '2021-10-18T16:39:28Z',
    pushed_at: '2021-10-18T16:39:25Z',
    git_url: 'git://github.com/SirZeck/javascript-basic-ajax-project.git',
    ssh_url: 'git@github.com:SirZeck/javascript-basic-ajax-project.git',
    clone_url: 'https://github.com/SirZeck/javascript-basic-ajax-project.git',
    svn_url: 'https://github.com/SirZeck/javascript-basic-ajax-project',
    homepage: null,
    size: 647,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 415074920,
    node_id: 'R_kgDOGL2KaA',
    name: 'javascript-basic-projects',
    full_name: 'SirZeck/javascript-basic-projects',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/javascript-basic-projects',
    description: null,
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/javascript-basic-projects',
    forks_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/javascript-basic-projects/deployments',
    created_at: '2021-10-08T17:34:10Z',
    updated_at: '2021-10-19T13:21:28Z',
    pushed_at: '2021-10-19T13:21:23Z',
    git_url: 'git://github.com/SirZeck/javascript-basic-projects.git',
    ssh_url: 'git@github.com:SirZeck/javascript-basic-projects.git',
    clone_url: 'https://github.com/SirZeck/javascript-basic-projects.git',
    svn_url: 'https://github.com/SirZeck/javascript-basic-projects',
    homepage: null,
    size: 7859,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'SCSS',
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 417465404,
    node_id: 'R_kgDOGOIEPA',
    name: 'javascript-oop-project',
    full_name: 'SirZeck/javascript-oop-project',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/javascript-oop-project',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/javascript-oop-project',
    forks_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/javascript-oop-project/deployments',
    created_at: '2021-10-15T10:53:11Z',
    updated_at: '2021-10-15T10:58:42Z',
    pushed_at: '2021-10-15T10:58:39Z',
    git_url: 'git://github.com/SirZeck/javascript-oop-project.git',
    ssh_url: 'git@github.com:SirZeck/javascript-oop-project.git',
    clone_url: 'https://github.com/SirZeck/javascript-oop-project.git',
    svn_url: 'https://github.com/SirZeck/javascript-oop-project',
    homepage: null,
    size: 1056,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 376753958,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzY3NTM5NTg=',
    name: 'kactl',
    full_name: 'SirZeck/kactl',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/kactl',
    description:
      'KTH ACM Contest Template Library (... eller KTHs AC-tillverkande lapp)',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/kactl',
    forks_url: 'https://api.github.com/repos/SirZeck/kactl/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/kactl/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/kactl/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/kactl/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/kactl/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/kactl/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/kactl/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/kactl/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/kactl/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/kactl/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/kactl/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/SirZeck/kactl/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/SirZeck/kactl/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/kactl/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/SirZeck/kactl/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/kactl/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/kactl/stargazers',
    contributors_url: 'https://api.github.com/repos/SirZeck/kactl/contributors',
    subscribers_url: 'https://api.github.com/repos/SirZeck/kactl/subscribers',
    subscription_url: 'https://api.github.com/repos/SirZeck/kactl/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/kactl/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/kactl/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/kactl/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/kactl/issues/comments{/number}',
    contents_url: 'https://api.github.com/repos/SirZeck/kactl/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/kactl/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/kactl/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/kactl/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/kactl/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/kactl/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/kactl/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/kactl/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/kactl/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/kactl/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/kactl/releases{/id}',
    deployments_url: 'https://api.github.com/repos/SirZeck/kactl/deployments',
    created_at: '2021-06-14T08:26:00Z',
    updated_at: '2021-06-14T08:26:01Z',
    pushed_at: '2019-04-05T14:25:12Z',
    git_url: 'git://github.com/SirZeck/kactl.git',
    ssh_url: 'git@github.com:SirZeck/kactl.git',
    clone_url: 'https://github.com/SirZeck/kactl.git',
    svn_url: 'https://github.com/SirZeck/kactl',
    homepage: '',
    size: 8012,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 307156254,
    node_id: 'MDEwOlJlcG9zaXRvcnkzMDcxNTYyNTQ=',
    name: 'kilo',
    full_name: 'SirZeck/kilo',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/kilo',
    description:
      'A text editor in less than 1000 LOC with syntax highlight and search.',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/kilo',
    forks_url: 'https://api.github.com/repos/SirZeck/kilo/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/kilo/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/kilo/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/kilo/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/kilo/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/kilo/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/kilo/events',
    assignees_url: 'https://api.github.com/repos/SirZeck/kilo/assignees{/user}',
    branches_url: 'https://api.github.com/repos/SirZeck/kilo/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/kilo/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/kilo/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/SirZeck/kilo/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/SirZeck/kilo/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/kilo/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/SirZeck/kilo/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/kilo/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/kilo/stargazers',
    contributors_url: 'https://api.github.com/repos/SirZeck/kilo/contributors',
    subscribers_url: 'https://api.github.com/repos/SirZeck/kilo/subscribers',
    subscription_url: 'https://api.github.com/repos/SirZeck/kilo/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/kilo/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/kilo/git/commits{/sha}',
    comments_url: 'https://api.github.com/repos/SirZeck/kilo/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/kilo/issues/comments{/number}',
    contents_url: 'https://api.github.com/repos/SirZeck/kilo/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/kilo/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/kilo/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/kilo/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/kilo/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/kilo/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/kilo/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/kilo/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/kilo/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/kilo/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/kilo/releases{/id}',
    deployments_url: 'https://api.github.com/repos/SirZeck/kilo/deployments',
    created_at: '2020-10-25T17:42:04Z',
    updated_at: '2020-10-25T17:42:06Z',
    pushed_at: '2020-10-21T02:00:28Z',
    git_url: 'git://github.com/SirZeck/kilo.git',
    ssh_url: 'git@github.com:SirZeck/kilo.git',
    clone_url: 'https://github.com/SirZeck/kilo.git',
    svn_url: 'https://github.com/SirZeck/kilo',
    homepage: null,
    size: 37,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'bsd-2-clause',
      name: 'BSD 2-Clause "Simplified" License',
      spdx_id: 'BSD-2-Clause',
      url: 'https://api.github.com/licenses/bsd-2-clause',
      node_id: 'MDc6TGljZW5zZTQ=',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 391336816,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTEzMzY4MTY=',
    name: 'lectures',
    full_name: 'SirZeck/lectures',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/lectures',
    description: 'Code shown in the lectures',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/lectures',
    forks_url: 'https://api.github.com/repos/SirZeck/lectures/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/lectures/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/lectures/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/lectures/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/lectures/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/lectures/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/lectures/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/lectures/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/lectures/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/lectures/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/lectures/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/lectures/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/lectures/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/lectures/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/lectures/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/lectures/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/lectures/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/lectures/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/lectures/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/lectures/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/lectures/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/lectures/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/lectures/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/lectures/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/lectures/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/lectures/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/lectures/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/lectures/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/lectures/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/lectures/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/lectures/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/lectures/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/lectures/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/lectures/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/lectures/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/lectures/deployments',
    created_at: '2021-07-31T11:27:59Z',
    updated_at: '2021-08-10T05:41:15Z',
    pushed_at: '2021-08-10T05:41:12Z',
    git_url: 'git://github.com/SirZeck/lectures.git',
    ssh_url: 'git@github.com:SirZeck/lectures.git',
    clone_url: 'https://github.com/SirZeck/lectures.git',
    svn_url: 'https://github.com/SirZeck/lectures',
    homepage: null,
    size: 50,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C++',
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'gpl-3.0',
      name: 'GNU General Public License v3.0',
      spdx_id: 'GPL-3.0',
      url: 'https://api.github.com/licenses/gpl-3.0',
      node_id: 'MDc6TGljZW5zZTk=',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 421667058,
    node_id: 'R_kgDOGSIg8g',
    name: 'LeetCode-Solutions',
    full_name: 'SirZeck/LeetCode-Solutions',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/LeetCode-Solutions',
    description: 'Search your LeetCode problem code.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/LeetCode-Solutions',
    forks_url: 'https://api.github.com/repos/SirZeck/LeetCode-Solutions/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/LeetCode-Solutions/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/LeetCode-Solutions/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/LeetCode-Solutions/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/LeetCode-Solutions/deployments',
    created_at: '2021-10-27T03:43:36Z',
    updated_at: '2021-11-01T05:11:56Z',
    pushed_at: '2021-11-01T05:09:32Z',
    git_url: 'git://github.com/SirZeck/LeetCode-Solutions.git',
    ssh_url: 'git@github.com:SirZeck/LeetCode-Solutions.git',
    clone_url: 'https://github.com/SirZeck/LeetCode-Solutions.git',
    svn_url: 'https://github.com/SirZeck/LeetCode-Solutions',
    homepage: 'https://sirzeck.github.io/LeetCode-Solutions/',
    size: 29,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C++',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['leetcode-cpp', 'leetcode-solutions'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 399918931,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTk5MTg5MzE=',
    name: 'linkedin-skill-assessments-quizzes',
    full_name: 'SirZeck/linkedin-skill-assessments-quizzes',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/linkedin-skill-assessments-quizzes',
    description:
      'Full reference of LinkedIn answers 2021 for skill assessments, LinkedIn test, questions and answers (aws-lambda, rest-api, javascript, react, git, html, jquery, mongodb, java, css, python, machine-learning, power-point) linkedin excel test lösungen, linkedin machine learning test',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes',
    forks_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/linkedin-skill-assessments-quizzes/deployments',
    created_at: '2021-08-25T18:24:37Z',
    updated_at: '2021-08-25T18:24:38Z',
    pushed_at: '2021-08-25T13:34:23Z',
    git_url: 'git://github.com/SirZeck/linkedin-skill-assessments-quizzes.git',
    ssh_url: 'git@github.com:SirZeck/linkedin-skill-assessments-quizzes.git',
    clone_url:
      'https://github.com/SirZeck/linkedin-skill-assessments-quizzes.git',
    svn_url: 'https://github.com/SirZeck/linkedin-skill-assessments-quizzes',
    homepage: 'https://ebazhanov.github.io/linkedin-skill-assessments-quizzes/',
    size: 75050,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'agpl-3.0',
      name: 'GNU Affero General Public License v3.0',
      spdx_id: 'AGPL-3.0',
      url: 'https://api.github.com/licenses/agpl-3.0',
      node_id: 'MDc6TGljZW5zZTE=',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 375011593,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzUwMTE1OTM=',
    name: 'LMR',
    full_name: 'SirZeck/LMR',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/LMR',
    description: "Luna's Magic Reference",
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/LMR',
    forks_url: 'https://api.github.com/repos/SirZeck/LMR/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/LMR/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/LMR/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/LMR/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/LMR/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/LMR/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/LMR/events',
    assignees_url: 'https://api.github.com/repos/SirZeck/LMR/assignees{/user}',
    branches_url: 'https://api.github.com/repos/SirZeck/LMR/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/LMR/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/LMR/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/SirZeck/LMR/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/SirZeck/LMR/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/LMR/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/SirZeck/LMR/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/LMR/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/LMR/stargazers',
    contributors_url: 'https://api.github.com/repos/SirZeck/LMR/contributors',
    subscribers_url: 'https://api.github.com/repos/SirZeck/LMR/subscribers',
    subscription_url: 'https://api.github.com/repos/SirZeck/LMR/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/LMR/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/LMR/git/commits{/sha}',
    comments_url: 'https://api.github.com/repos/SirZeck/LMR/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/LMR/issues/comments{/number}',
    contents_url: 'https://api.github.com/repos/SirZeck/LMR/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/LMR/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/LMR/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/LMR/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/LMR/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/LMR/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/LMR/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/LMR/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/LMR/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/LMR/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/LMR/releases{/id}',
    deployments_url: 'https://api.github.com/repos/SirZeck/LMR/deployments',
    created_at: '2021-06-08T13:03:47Z',
    updated_at: '2021-06-08T13:03:48Z',
    pushed_at: '2019-08-01T00:08:28Z',
    git_url: 'git://github.com/SirZeck/LMR.git',
    ssh_url: 'git@github.com:SirZeck/LMR.git',
    clone_url: 'https://github.com/SirZeck/LMR.git',
    svn_url: 'https://github.com/SirZeck/LMR',
    homepage: null,
    size: 100273,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 402056936,
    node_id: 'MDEwOlJlcG9zaXRvcnk0MDIwNTY5MzY=',
    name: 'mentoring',
    full_name: 'SirZeck/mentoring',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/mentoring',
    description: '👩🏿‍🎓👨🏽‍🎓👩🏻‍🎓CNCF Mentoring + CommunityBridge + Summer of Code',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/mentoring',
    forks_url: 'https://api.github.com/repos/SirZeck/mentoring/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/mentoring/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/mentoring/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/mentoring/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/mentoring/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/mentoring/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/mentoring/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/mentoring/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/mentoring/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/mentoring/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/mentoring/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/mentoring/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/mentoring/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/mentoring/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/mentoring/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/mentoring/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/mentoring/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/mentoring/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/mentoring/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/mentoring/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/mentoring/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/mentoring/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/mentoring/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/mentoring/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/mentoring/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/mentoring/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/mentoring/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/mentoring/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/mentoring/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/mentoring/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/mentoring/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/mentoring/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/mentoring/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/mentoring/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/mentoring/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/mentoring/deployments',
    created_at: '2021-09-01T12:43:29Z',
    updated_at: '2021-09-01T12:43:30Z',
    pushed_at: '2021-08-19T16:53:34Z',
    git_url: 'git://github.com/SirZeck/mentoring.git',
    ssh_url: 'git@github.com:SirZeck/mentoring.git',
    clone_url: 'https://github.com/SirZeck/mentoring.git',
    svn_url: 'https://github.com/SirZeck/mentoring',
    homepage: 'https://mentoring.cncf.io',
    size: 1149,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'apache-2.0',
      name: 'Apache License 2.0',
      spdx_id: 'Apache-2.0',
      url: 'https://api.github.com/licenses/apache-2.0',
      node_id: 'MDc6TGljZW5zZTI=',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 404452592,
    node_id: 'MDEwOlJlcG9zaXRvcnk0MDQ0NTI1OTI=',
    name: 'meshery',
    full_name: 'SirZeck/meshery',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/meshery',
    description: 'Meshery, the service mesh management plane',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/meshery',
    forks_url: 'https://api.github.com/repos/SirZeck/meshery/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/meshery/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/meshery/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/meshery/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/meshery/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/meshery/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/meshery/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/meshery/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/meshery/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/meshery/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/meshery/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/SirZeck/meshery/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/SirZeck/meshery/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/meshery/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/SirZeck/meshery/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/meshery/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/meshery/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/meshery/contributors',
    subscribers_url: 'https://api.github.com/repos/SirZeck/meshery/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/meshery/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/meshery/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/meshery/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/meshery/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/meshery/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/meshery/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/meshery/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/meshery/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/meshery/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/meshery/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/meshery/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/meshery/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/meshery/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/meshery/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/meshery/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/meshery/releases{/id}',
    deployments_url: 'https://api.github.com/repos/SirZeck/meshery/deployments',
    created_at: '2021-09-08T18:22:10Z',
    updated_at: '2021-09-20T09:45:01Z',
    pushed_at: '2021-09-20T11:13:49Z',
    git_url: 'git://github.com/SirZeck/meshery.git',
    ssh_url: 'git@github.com:SirZeck/meshery.git',
    clone_url: 'https://github.com/SirZeck/meshery.git',
    svn_url: 'https://github.com/SirZeck/meshery',
    homepage: 'https://meshery.io',
    size: 132646,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'Go',
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'apache-2.0',
      name: 'Apache License 2.0',
      spdx_id: 'Apache-2.0',
      url: 'https://api.github.com/licenses/apache-2.0',
      node_id: 'MDc6TGljZW5zZTI=',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 404471069,
    node_id: 'MDEwOlJlcG9zaXRvcnk0MDQ0NzEwNjk=',
    name: 'meshery-tanzu-sm',
    full_name: 'SirZeck/meshery-tanzu-sm',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/meshery-tanzu-sm',
    description: 'Meshery adapter for VMware Tanzu Service Mesh',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/meshery-tanzu-sm',
    forks_url: 'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/meshery-tanzu-sm/deployments',
    created_at: '2021-09-08T19:29:13Z',
    updated_at: '2021-09-08T19:36:05Z',
    pushed_at: '2021-09-08T19:36:01Z',
    git_url: 'git://github.com/SirZeck/meshery-tanzu-sm.git',
    ssh_url: 'git@github.com:SirZeck/meshery-tanzu-sm.git',
    clone_url: 'https://github.com/SirZeck/meshery-tanzu-sm.git',
    svn_url: 'https://github.com/SirZeck/meshery-tanzu-sm',
    homepage: 'https://docs.meshery.io',
    size: 192,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'Go',
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'apache-2.0',
      name: 'Apache License 2.0',
      spdx_id: 'Apache-2.0',
      url: 'https://api.github.com/licenses/apache-2.0',
      node_id: 'MDc6TGljZW5zZTI=',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 375725192,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzU3MjUxOTI=',
    name: 'modern-cpp-tricks',
    full_name: 'SirZeck/modern-cpp-tricks',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/modern-cpp-tricks',
    description:
      'Modern CPP Tricks often useful in Coding Interviews and Competitive Programming',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/modern-cpp-tricks',
    forks_url: 'https://api.github.com/repos/SirZeck/modern-cpp-tricks/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/modern-cpp-tricks/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/modern-cpp-tricks/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/modern-cpp-tricks/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/modern-cpp-tricks/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/modern-cpp-tricks/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/modern-cpp-tricks/deployments',
    created_at: '2021-06-10T14:25:23Z',
    updated_at: '2021-06-10T14:25:23Z',
    pushed_at: '2021-06-06T08:39:03Z',
    git_url: 'git://github.com/SirZeck/modern-cpp-tricks.git',
    ssh_url: 'git@github.com:SirZeck/modern-cpp-tricks.git',
    clone_url: 'https://github.com/SirZeck/modern-cpp-tricks.git',
    svn_url: 'https://github.com/SirZeck/modern-cpp-tricks',
    homepage: '',
    size: 9,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 423810456,
    node_id: 'R_kgDOGULVmA',
    name: 'Movie-DB',
    full_name: 'SirZeck/Movie-DB',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Movie-DB',
    description: 'A movie-Db react app to search your next favorite movie.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Movie-DB',
    forks_url: 'https://api.github.com/repos/SirZeck/Movie-DB/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/Movie-DB/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Movie-DB/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Movie-DB/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/Movie-DB/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Movie-DB/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/Movie-DB/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/Movie-DB/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/Movie-DB/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/Movie-DB/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/Movie-DB/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/Movie-DB/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/Movie-DB/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/Movie-DB/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/Movie-DB/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/Movie-DB/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/Movie-DB/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Movie-DB/deployments',
    created_at: '2021-11-02T11:06:04Z',
    updated_at: '2021-11-02T11:31:30Z',
    pushed_at: '2021-11-02T11:31:27Z',
    git_url: 'git://github.com/SirZeck/Movie-DB.git',
    ssh_url: 'git@github.com:SirZeck/Movie-DB.git',
    clone_url: 'https://github.com/SirZeck/Movie-DB.git',
    svn_url: 'https://github.com/SirZeck/Movie-DB',
    homepage: 'https://muvie-db.netlify.app/',
    size: 497,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['omdb-api', 'react'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 404661341,
    node_id: 'MDEwOlJlcG9zaXRvcnk0MDQ2NjEzNDE=',
    name: 'open-event-frontend',
    full_name: 'SirZeck/open-event-frontend',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/open-event-frontend',
    description: 'The frontend for the Open Event API Server',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/open-event-frontend',
    forks_url: 'https://api.github.com/repos/SirZeck/open-event-frontend/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/open-event-frontend/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/open-event-frontend/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/open-event-frontend/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/open-event-frontend/deployments',
    created_at: '2021-09-09T09:26:25Z',
    updated_at: '2021-09-09T09:26:26Z',
    pushed_at: '2021-09-09T09:20:18Z',
    git_url: 'git://github.com/SirZeck/open-event-frontend.git',
    ssh_url: 'git@github.com:SirZeck/open-event-frontend.git',
    clone_url: 'https://github.com/SirZeck/open-event-frontend.git',
    svn_url: 'https://github.com/SirZeck/open-event-frontend',
    homepage: 'https://eventyay.com',
    size: 48068,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'apache-2.0',
      name: 'Apache License 2.0',
      spdx_id: 'Apache-2.0',
      url: 'https://api.github.com/licenses/apache-2.0',
      node_id: 'MDc6TGljZW5zZTI=',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'development',
  },
  {
    id: 416384578,
    node_id: 'R_kgDOGNGGQg',
    name: 'paragraph-generator',
    full_name: 'SirZeck/paragraph-generator',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/paragraph-generator',
    description: 'A simple paragraph generator for your lorem ipsum project.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/paragraph-generator',
    forks_url: 'https://api.github.com/repos/SirZeck/paragraph-generator/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/paragraph-generator/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/paragraph-generator/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/paragraph-generator/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/paragraph-generator/deployments',
    created_at: '2021-10-12T15:06:06Z',
    updated_at: '2021-10-12T15:24:58Z',
    pushed_at: '2021-10-12T15:21:46Z',
    git_url: 'git://github.com/SirZeck/paragraph-generator.git',
    ssh_url: 'git@github.com:SirZeck/paragraph-generator.git',
    clone_url: 'https://github.com/SirZeck/paragraph-generator.git',
    svn_url: 'https://github.com/SirZeck/paragraph-generator',
    homepage: 'https://sirzeck.github.io/paragraph-generator/',
    size: 9,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['css', 'html', 'javascript'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 376015615,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzYwMTU2MTU=',
    name: 'programming-library',
    full_name: 'SirZeck/programming-library',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/programming-library',
    description: null,
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/programming-library',
    forks_url: 'https://api.github.com/repos/SirZeck/programming-library/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/programming-library/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/programming-library/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/programming-library/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/programming-library/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/programming-library/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/programming-library/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/programming-library/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/programming-library/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/programming-library/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/programming-library/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/programming-library/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/programming-library/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/programming-library/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/programming-library/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/programming-library/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/programming-library/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/programming-library/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/programming-library/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/programming-library/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/programming-library/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/programming-library/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/programming-library/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/programming-library/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/programming-library/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/programming-library/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/programming-library/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/programming-library/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/programming-library/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/programming-library/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/programming-library/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/programming-library/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/programming-library/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/programming-library/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/programming-library/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/programming-library/deployments',
    created_at: '2021-06-11T12:19:35Z',
    updated_at: '2021-06-11T12:19:36Z',
    pushed_at: '2021-06-09T20:20:56Z',
    git_url: 'git://github.com/SirZeck/programming-library.git',
    ssh_url: 'git@github.com:SirZeck/programming-library.git',
    clone_url: 'https://github.com/SirZeck/programming-library.git',
    svn_url: 'https://github.com/SirZeck/programming-library',
    homepage: null,
    size: 159,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 404661657,
    node_id: 'MDEwOlJlcG9zaXRvcnk0MDQ2NjE2NTc=',
    name: 'pslab-python',
    full_name: 'SirZeck/pslab-python',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/pslab-python',
    description: 'Python Library for PSLab Desktop: https://pslab.io',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/pslab-python',
    forks_url: 'https://api.github.com/repos/SirZeck/pslab-python/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/pslab-python/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/pslab-python/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/pslab-python/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/pslab-python/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/pslab-python/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/pslab-python/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/pslab-python/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/pslab-python/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/pslab-python/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/pslab-python/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/pslab-python/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/pslab-python/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/pslab-python/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/pslab-python/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/pslab-python/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/pslab-python/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/pslab-python/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/pslab-python/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/pslab-python/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/pslab-python/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/pslab-python/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/pslab-python/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/pslab-python/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/pslab-python/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/pslab-python/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/pslab-python/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/pslab-python/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/pslab-python/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/pslab-python/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/pslab-python/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/pslab-python/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/pslab-python/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/pslab-python/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/pslab-python/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/pslab-python/deployments',
    created_at: '2021-09-09T09:27:36Z',
    updated_at: '2021-09-09T09:27:37Z',
    pushed_at: '2021-08-24T08:57:01Z',
    git_url: 'git://github.com/SirZeck/pslab-python.git',
    ssh_url: 'git@github.com:SirZeck/pslab-python.git',
    clone_url: 'https://github.com/SirZeck/pslab-python.git',
    svn_url: 'https://github.com/SirZeck/pslab-python',
    homepage: '',
    size: 16690,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'gpl-3.0',
      name: 'GNU General Public License v3.0',
      spdx_id: 'GPL-3.0',
      url: 'https://api.github.com/licenses/gpl-3.0',
      node_id: 'MDc6TGljZW5zZTk=',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'development',
  },
  {
    id: 395076402,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTUwNzY0MDI=',
    name: 'QR-Code-generator',
    full_name: 'SirZeck/QR-Code-generator',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/QR-Code-generator',
    description:
      'High-quality QR Code generator library in Java, TypeScript/JavaScript, Python, C++, C, Rust.',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/QR-Code-generator',
    forks_url: 'https://api.github.com/repos/SirZeck/QR-Code-generator/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/QR-Code-generator/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/QR-Code-generator/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/QR-Code-generator/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/QR-Code-generator/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/QR-Code-generator/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/QR-Code-generator/deployments',
    created_at: '2021-08-11T18:02:39Z',
    updated_at: '2021-08-11T18:02:40Z',
    pushed_at: '2021-08-11T17:55:04Z',
    git_url: 'git://github.com/SirZeck/QR-Code-generator.git',
    ssh_url: 'git@github.com:SirZeck/QR-Code-generator.git',
    clone_url: 'https://github.com/SirZeck/QR-Code-generator.git',
    svn_url: 'https://github.com/SirZeck/QR-Code-generator',
    homepage: 'https://www.nayuki.io/page/qr-code-generator-library',
    size: 1124,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 424495490,
    node_id: 'R_kgDOGU1Jgg',
    name: 'Quiz-React-App',
    full_name: 'SirZeck/Quiz-React-App',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Quiz-React-App',
    description:
      'Generate some random questions on your interested topic and test out your knowledge.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Quiz-React-App',
    forks_url: 'https://api.github.com/repos/SirZeck/Quiz-React-App/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Quiz-React-App/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Quiz-React-App/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/Quiz-React-App/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Quiz-React-App/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/Quiz-React-App/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Quiz-React-App/deployments',
    created_at: '2021-11-04T06:36:29Z',
    updated_at: '2021-11-04T06:50:30Z',
    pushed_at: '2021-11-04T06:48:41Z',
    git_url: 'git://github.com/SirZeck/Quiz-React-App.git',
    ssh_url: 'git@github.com:SirZeck/Quiz-React-App.git',
    clone_url: 'https://github.com/SirZeck/Quiz-React-App.git',
    svn_url: 'https://github.com/SirZeck/Quiz-React-App',
    homepage: 'https://quick-trivia-app.netlify.app/',
    size: 174,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['opentrivia-api', 'quizapp', 'react'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 420610001,
    node_id: 'R_kgDOGRH_0Q',
    name: 'react-projects',
    full_name: 'SirZeck/react-projects',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/react-projects',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/react-projects',
    forks_url: 'https://api.github.com/repos/SirZeck/react-projects/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/react-projects/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/react-projects/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/react-projects/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/react-projects/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/react-projects/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/react-projects/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/react-projects/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/react-projects/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/react-projects/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/react-projects/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/react-projects/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/react-projects/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/react-projects/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/react-projects/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/react-projects/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/react-projects/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/react-projects/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/react-projects/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/react-projects/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/react-projects/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/react-projects/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/react-projects/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/react-projects/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/react-projects/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/react-projects/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/react-projects/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/react-projects/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/react-projects/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/react-projects/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/react-projects/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/react-projects/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/react-projects/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/react-projects/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/react-projects/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/react-projects/deployments',
    created_at: '2021-10-24T06:53:00Z',
    updated_at: '2021-11-04T06:29:28Z',
    pushed_at: '2021-11-04T06:29:25Z',
    git_url: 'git://github.com/SirZeck/react-projects.git',
    ssh_url: 'git@github.com:SirZeck/react-projects.git',
    clone_url: 'https://github.com/SirZeck/react-projects.git',
    svn_url: 'https://github.com/SirZeck/react-projects',
    homepage: '',
    size: 2455,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['react'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 424866791,
    node_id: 'R_kgDOGVLz5w',
    name: 'Search-Github-Users',
    full_name: 'SirZeck/Search-Github-Users',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Search-Github-Users',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Search-Github-Users',
    forks_url: 'https://api.github.com/repos/SirZeck/Search-Github-Users/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Search-Github-Users/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Search-Github-Users/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Search-Github-Users/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Search-Github-Users/deployments',
    created_at: '2021-11-05T07:48:37Z',
    updated_at: '2021-11-05T07:55:06Z',
    pushed_at: '2021-11-05T07:55:03Z',
    git_url: 'git://github.com/SirZeck/Search-Github-Users.git',
    ssh_url: 'git@github.com:SirZeck/Search-Github-Users.git',
    clone_url: 'https://github.com/SirZeck/Search-Github-Users.git',
    svn_url: 'https://github.com/SirZeck/Search-Github-Users',
    homepage: null,
    size: 293,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 412530518,
    node_id: 'R_kgDOGJa3Vg',
    name: 'service-mesh-performance',
    full_name: 'SirZeck/service-mesh-performance',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/service-mesh-performance',
    description: 'Standardizing Service Mesh Value Measurement',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/service-mesh-performance',
    forks_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/service-mesh-performance/deployments',
    created_at: '2021-10-01T15:57:48Z',
    updated_at: '2021-10-01T15:57:49Z',
    pushed_at: '2021-09-30T20:48:41Z',
    git_url: 'git://github.com/SirZeck/service-mesh-performance.git',
    ssh_url: 'git@github.com:SirZeck/service-mesh-performance.git',
    clone_url: 'https://github.com/SirZeck/service-mesh-performance.git',
    svn_url: 'https://github.com/SirZeck/service-mesh-performance',
    homepage: 'https://smp-spec.io',
    size: 28976,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'apache-2.0',
      name: 'Apache License 2.0',
      spdx_id: 'Apache-2.0',
      url: 'https://api.github.com/licenses/apache-2.0',
      node_id: 'MDc6TGljZW5zZTI=',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 410919379,
    node_id: 'R_kgDOGH4h0w',
    name: 'Simple-Todo',
    full_name: 'SirZeck/Simple-Todo',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Simple-Todo',
    description: 'Built as a learning project for React.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Simple-Todo',
    forks_url: 'https://api.github.com/repos/SirZeck/Simple-Todo/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/Simple-Todo/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Simple-Todo/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Simple-Todo/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/Simple-Todo/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Simple-Todo/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/Simple-Todo/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/Simple-Todo/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/Simple-Todo/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Simple-Todo/deployments',
    created_at: '2021-09-27T14:31:28Z',
    updated_at: '2021-10-01T10:02:55Z',
    pushed_at: '2021-10-01T10:02:53Z',
    git_url: 'git://github.com/SirZeck/Simple-Todo.git',
    ssh_url: 'git@github.com:SirZeck/Simple-Todo.git',
    clone_url: 'https://github.com/SirZeck/Simple-Todo.git',
    svn_url: 'https://github.com/SirZeck/Simple-Todo',
    homepage: 'https://simple-teudoo.netlify.app/',
    size: 528,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['react', 'todo-list'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 416373281,
    node_id: 'R_kgDOGNFaIQ',
    name: 'SimpleEQ',
    full_name: 'SirZeck/SimpleEQ',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/SimpleEQ',
    description: 'An audio plugin created using C++ and JUCE Framework.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/SimpleEQ',
    forks_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/SimpleEQ/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/SimpleEQ/deployments',
    created_at: '2021-10-12T14:35:08Z',
    updated_at: '2021-10-14T11:39:39Z',
    pushed_at: '2021-10-14T11:39:36Z',
    git_url: 'git://github.com/SirZeck/SimpleEQ.git',
    ssh_url: 'git@github.com:SirZeck/SimpleEQ.git',
    clone_url: 'https://github.com/SirZeck/SimpleEQ.git',
    svn_url: 'https://github.com/SirZeck/SimpleEQ',
    homepage: null,
    size: 6,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C++',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 399579415,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTk1Nzk0MTU=',
    name: 'sre-interview-prep-guide',
    full_name: 'SirZeck/sre-interview-prep-guide',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/sre-interview-prep-guide',
    description: 'Site Reliability Engineer Interview Preparation Guide',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/sre-interview-prep-guide',
    forks_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/sre-interview-prep-guide/deployments',
    created_at: '2021-08-24T19:17:55Z',
    updated_at: '2021-08-24T19:17:57Z',
    pushed_at: '2021-06-08T01:14:23Z',
    git_url: 'git://github.com/SirZeck/sre-interview-prep-guide.git',
    ssh_url: 'git@github.com:SirZeck/sre-interview-prep-guide.git',
    clone_url: 'https://github.com/SirZeck/sre-interview-prep-guide.git',
    svn_url: 'https://github.com/SirZeck/sre-interview-prep-guide',
    homepage: null,
    size: 76,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 418942667,
    node_id: 'R_kgDOGPiOyw',
    name: 'Stripe-Frontend-clone',
    full_name: 'SirZeck/Stripe-Frontend-clone',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Stripe-Frontend-clone',
    description: 'A frontend clone of Stripe website.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone',
    forks_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-clone/deployments',
    created_at: '2021-10-19T13:44:51Z',
    updated_at: '2021-10-31T09:49:11Z',
    pushed_at: '2021-10-31T09:49:08Z',
    git_url: 'git://github.com/SirZeck/Stripe-Frontend-clone.git',
    ssh_url: 'git@github.com:SirZeck/Stripe-Frontend-clone.git',
    clone_url: 'https://github.com/SirZeck/Stripe-Frontend-clone.git',
    svn_url: 'https://github.com/SirZeck/Stripe-Frontend-clone',
    homepage: 'https://sirzeck.github.io/Stripe-Frontend-clone/',
    size: 56,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['clone', 'javascript'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 423106505,
    node_id: 'R_kgDOGTgXyQ',
    name: 'Stripe-Frontend-React-Clone',
    full_name: 'SirZeck/Stripe-Frontend-React-Clone',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Stripe-Frontend-React-Clone',
    description: 'A frontend clone of Stripe website using React.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone',
    forks_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Stripe-Frontend-React-Clone/deployments',
    created_at: '2021-10-31T09:40:58Z',
    updated_at: '2021-10-31T09:48:10Z',
    pushed_at: '2021-10-31T09:44:39Z',
    git_url: 'git://github.com/SirZeck/Stripe-Frontend-React-Clone.git',
    ssh_url: 'git@github.com:SirZeck/Stripe-Frontend-React-Clone.git',
    clone_url: 'https://github.com/SirZeck/Stripe-Frontend-React-Clone.git',
    svn_url: 'https://github.com/SirZeck/Stripe-Frontend-React-Clone',
    homepage: 'https://stripe-frontend-clone.netlify.app/',
    size: 222,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['react', 'stripe-submenu'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 399579571,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTk1Nzk1NzE=',
    name: 'system-design-primer',
    full_name: 'SirZeck/system-design-primer',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/system-design-primer',
    description:
      'Learn how to design large-scale systems. Prep for the system design interview.  Includes Anki flashcards.',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/system-design-primer',
    forks_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/system-design-primer/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/system-design-primer/deployments',
    created_at: '2021-08-24T19:18:37Z',
    updated_at: '2021-08-24T19:18:38Z',
    pushed_at: '2021-08-24T03:14:19Z',
    git_url: 'git://github.com/SirZeck/system-design-primer.git',
    ssh_url: 'git@github.com:SirZeck/system-design-primer.git',
    clone_url: 'https://github.com/SirZeck/system-design-primer.git',
    svn_url: 'https://github.com/SirZeck/system-design-primer',
    homepage: '',
    size: 11152,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'other',
      name: 'Other',
      spdx_id: 'NOASSERTION',
      url: null,
      node_id: 'MDc6TGljZW5zZTA=',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 393644281,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTM2NDQyODE=',
    name: 'test_db',
    full_name: 'SirZeck/test_db',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/test_db',
    description:
      'A sample MySQL database with an integrated test suite, used to test your applications and database servers',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/test_db',
    forks_url: 'https://api.github.com/repos/SirZeck/test_db/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/test_db/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/test_db/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/test_db/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/test_db/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/test_db/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/test_db/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/test_db/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/test_db/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/test_db/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/test_db/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/SirZeck/test_db/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/SirZeck/test_db/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/test_db/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/SirZeck/test_db/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/test_db/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/test_db/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/test_db/contributors',
    subscribers_url: 'https://api.github.com/repos/SirZeck/test_db/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/test_db/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/test_db/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/test_db/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/test_db/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/test_db/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/test_db/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/test_db/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/test_db/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/test_db/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/test_db/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/test_db/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/test_db/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/test_db/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/test_db/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/test_db/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/test_db/releases{/id}',
    deployments_url: 'https://api.github.com/repos/SirZeck/test_db/deployments',
    created_at: '2021-08-07T09:55:09Z',
    updated_at: '2021-08-07T09:55:10Z',
    pushed_at: '2021-06-27T14:13:02Z',
    git_url: 'git://github.com/SirZeck/test_db.git',
    ssh_url: 'git@github.com:SirZeck/test_db.git',
    clone_url: 'https://github.com/SirZeck/test_db.git',
    svn_url: 'https://github.com/SirZeck/test_db',
    homepage: '',
    size: 76051,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 389871136,
    node_id: 'MDEwOlJlcG9zaXRvcnkzODk4NzExMzY=',
    name: 'tut',
    full_name: 'SirZeck/tut',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/tut',
    description: 'just practicing',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/tut',
    forks_url: 'https://api.github.com/repos/SirZeck/tut/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/tut/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/tut/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/tut/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/tut/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/tut/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/tut/events',
    assignees_url: 'https://api.github.com/repos/SirZeck/tut/assignees{/user}',
    branches_url: 'https://api.github.com/repos/SirZeck/tut/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/tut/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/tut/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/SirZeck/tut/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/SirZeck/tut/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/tut/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/SirZeck/tut/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/tut/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/tut/stargazers',
    contributors_url: 'https://api.github.com/repos/SirZeck/tut/contributors',
    subscribers_url: 'https://api.github.com/repos/SirZeck/tut/subscribers',
    subscription_url: 'https://api.github.com/repos/SirZeck/tut/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/tut/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/tut/git/commits{/sha}',
    comments_url: 'https://api.github.com/repos/SirZeck/tut/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/tut/issues/comments{/number}',
    contents_url: 'https://api.github.com/repos/SirZeck/tut/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/tut/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/tut/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/tut/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/tut/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/tut/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/tut/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/tut/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/tut/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/tut/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/tut/releases{/id}',
    deployments_url: 'https://api.github.com/repos/SirZeck/tut/deployments',
    created_at: '2021-07-27T06:22:57Z',
    updated_at: '2021-07-27T06:26:04Z',
    pushed_at: '2021-07-27T06:26:01Z',
    git_url: 'git://github.com/SirZeck/tut.git',
    ssh_url: 'git@github.com:SirZeck/tut.git',
    clone_url: 'https://github.com/SirZeck/tut.git',
    svn_url: 'https://github.com/SirZeck/tut',
    homepage: null,
    size: 0,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 418934506,
    node_id: 'R_kgDOGPhu6g',
    name: 'Wall-Of-Fellow-Devs',
    full_name: 'SirZeck/Wall-Of-Fellow-Devs',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Wall-Of-Fellow-Devs',
    description: 'A wall of my follow developers and programmers.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs',
    forks_url: 'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs/deployments',
    created_at: '2021-10-19T13:23:41Z',
    updated_at: '2021-11-01T11:01:21Z',
    pushed_at: '2021-11-01T11:00:56Z',
    git_url: 'git://github.com/SirZeck/Wall-Of-Fellow-Devs.git',
    ssh_url: 'git@github.com:SirZeck/Wall-Of-Fellow-Devs.git',
    clone_url: 'https://github.com/SirZeck/Wall-Of-Fellow-Devs.git',
    svn_url: 'https://github.com/SirZeck/Wall-Of-Fellow-Devs',
    homepage: 'https://sirzeck.github.io/Wall-Of-Fellow-Devs/',
    size: 5,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['javasript', 'paginated-results', 'wall'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 423430688,
    node_id: 'R_kgDOGT0KIA',
    name: 'Wall-Of-Fellow-Devs-React',
    full_name: 'SirZeck/Wall-Of-Fellow-Devs-React',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/Wall-Of-Fellow-Devs-React',
    description: 'A wall of my follow developers and programmers.',
    fork: false,
    url: 'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React',
    forks_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/teams',
    hooks_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/Wall-Of-Fellow-Devs-React/deployments',
    created_at: '2021-11-01T10:54:45Z',
    updated_at: '2021-11-02T08:17:28Z',
    pushed_at: '2021-11-01T11:03:45Z',
    git_url: 'git://github.com/SirZeck/Wall-Of-Fellow-Devs-React.git',
    ssh_url: 'git@github.com:SirZeck/Wall-Of-Fellow-Devs-React.git',
    clone_url: 'https://github.com/SirZeck/Wall-Of-Fellow-Devs-React.git',
    svn_url: 'https://github.com/SirZeck/Wall-Of-Fellow-Devs-React',
    homepage: 'https://wall-of-fellow-devs.netlify.app/',
    size: 170,
    stargazers_count: 1,
    watchers_count: 1,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    topics: ['paginated-results', 'react'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: 'main',
  },
  {
    id: 413839740,
    node_id: 'R_kgDOGKqxfA',
    name: 'You-Dont-Know-JS',
    full_name: 'SirZeck/You-Dont-Know-JS',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/You-Dont-Know-JS',
    description: 'A book series on JavaScript. @YDKJS on twitter.',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/You-Dont-Know-JS',
    forks_url: 'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/forks',
    keys_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/tags',
    blobs_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/languages',
    stargazers_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/subscription',
    commits_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/downloads',
    issues_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/labels{/name}',
    releases_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/You-Dont-Know-JS/deployments',
    created_at: '2021-10-05T13:56:10Z',
    updated_at: '2021-10-05T13:56:11Z',
    pushed_at: '2021-09-22T03:56:43Z',
    git_url: 'git://github.com/SirZeck/You-Dont-Know-JS.git',
    ssh_url: 'git@github.com:SirZeck/You-Dont-Know-JS.git',
    clone_url: 'https://github.com/SirZeck/You-Dont-Know-JS.git',
    svn_url: 'https://github.com/SirZeck/You-Dont-Know-JS',
    homepage: '',
    size: 10654,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'other',
      name: 'Other',
      spdx_id: 'NOASSERTION',
      url: null,
      node_id: 'MDc6TGljZW5zZTA=',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: '2nd-ed',
  },
  {
    id: 375464622,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzU0NjQ2MjI=',
    name: 'youtube',
    full_name: 'SirZeck/youtube',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/youtube',
    description: 'codes for my streams and YT videos',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/youtube',
    forks_url: 'https://api.github.com/repos/SirZeck/youtube/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/youtube/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/youtube/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/youtube/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/youtube/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/youtube/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/youtube/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/youtube/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/youtube/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/youtube/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/youtube/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/SirZeck/youtube/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/SirZeck/youtube/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/youtube/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/SirZeck/youtube/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/youtube/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/youtube/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/youtube/contributors',
    subscribers_url: 'https://api.github.com/repos/SirZeck/youtube/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/youtube/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/youtube/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/youtube/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/youtube/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/youtube/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/youtube/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/youtube/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/youtube/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/youtube/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/youtube/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/youtube/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/youtube/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/youtube/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/youtube/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/youtube/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/youtube/releases{/id}',
    deployments_url: 'https://api.github.com/repos/SirZeck/youtube/deployments',
    created_at: '2021-06-09T19:13:53Z',
    updated_at: '2021-06-09T19:13:54Z',
    pushed_at: '2021-05-01T17:59:47Z',
    git_url: 'git://github.com/SirZeck/youtube.git',
    ssh_url: 'git@github.com:SirZeck/youtube.git',
    clone_url: 'https://github.com/SirZeck/youtube.git',
    svn_url: 'https://github.com/SirZeck/youtube',
    homepage: null,
    size: 1216,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 411566290,
    node_id: 'R_kgDOGIgA0g',
    name: 'zola-sam',
    full_name: 'SirZeck/zola-sam',
    private: false,
    owner: {
      login: 'SirZeck',
      id: 52738298,
      node_id: 'MDQ6VXNlcjUyNzM4Mjk4',
      avatar_url: 'https://avatars.githubusercontent.com/u/52738298?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/SirZeck',
      html_url: 'https://github.com/SirZeck',
      followers_url: 'https://api.github.com/users/SirZeck/followers',
      following_url:
        'https://api.github.com/users/SirZeck/following{/other_user}',
      gists_url: 'https://api.github.com/users/SirZeck/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/SirZeck/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/SirZeck/subscriptions',
      organizations_url: 'https://api.github.com/users/SirZeck/orgs',
      repos_url: 'https://api.github.com/users/SirZeck/repos',
      events_url: 'https://api.github.com/users/SirZeck/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/SirZeck/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/SirZeck/zola-sam',
    description:
      ':globe_with_meridians: A Simple and Minimalist theme with a focus on typography and content.',
    fork: true,
    url: 'https://api.github.com/repos/SirZeck/zola-sam',
    forks_url: 'https://api.github.com/repos/SirZeck/zola-sam/forks',
    keys_url: 'https://api.github.com/repos/SirZeck/zola-sam/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/SirZeck/zola-sam/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/SirZeck/zola-sam/teams',
    hooks_url: 'https://api.github.com/repos/SirZeck/zola-sam/hooks',
    issue_events_url:
      'https://api.github.com/repos/SirZeck/zola-sam/issues/events{/number}',
    events_url: 'https://api.github.com/repos/SirZeck/zola-sam/events',
    assignees_url:
      'https://api.github.com/repos/SirZeck/zola-sam/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/SirZeck/zola-sam/branches{/branch}',
    tags_url: 'https://api.github.com/repos/SirZeck/zola-sam/tags',
    blobs_url: 'https://api.github.com/repos/SirZeck/zola-sam/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/SirZeck/zola-sam/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/SirZeck/zola-sam/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/SirZeck/zola-sam/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/SirZeck/zola-sam/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/SirZeck/zola-sam/languages',
    stargazers_url: 'https://api.github.com/repos/SirZeck/zola-sam/stargazers',
    contributors_url:
      'https://api.github.com/repos/SirZeck/zola-sam/contributors',
    subscribers_url:
      'https://api.github.com/repos/SirZeck/zola-sam/subscribers',
    subscription_url:
      'https://api.github.com/repos/SirZeck/zola-sam/subscription',
    commits_url: 'https://api.github.com/repos/SirZeck/zola-sam/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/SirZeck/zola-sam/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/SirZeck/zola-sam/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/SirZeck/zola-sam/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/SirZeck/zola-sam/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/SirZeck/zola-sam/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/SirZeck/zola-sam/merges',
    archive_url:
      'https://api.github.com/repos/SirZeck/zola-sam/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/SirZeck/zola-sam/downloads',
    issues_url: 'https://api.github.com/repos/SirZeck/zola-sam/issues{/number}',
    pulls_url: 'https://api.github.com/repos/SirZeck/zola-sam/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/SirZeck/zola-sam/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/SirZeck/zola-sam/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/SirZeck/zola-sam/labels{/name}',
    releases_url: 'https://api.github.com/repos/SirZeck/zola-sam/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/SirZeck/zola-sam/deployments',
    created_at: '2021-09-29T07:05:26Z',
    updated_at: '2021-09-29T07:05:27Z',
    pushed_at: '2021-02-10T17:02:40Z',
    git_url: 'git://github.com/SirZeck/zola-sam.git',
    ssh_url: 'git@github.com:SirZeck/zola-sam.git',
    clone_url: 'https://github.com/SirZeck/zola-sam.git',
    svn_url: 'https://github.com/SirZeck/zola-sam',
    homepage: 'https://zola-sam.janbaudisch.dev',
    size: 137,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'agpl-3.0',
      name: 'GNU Affero General Public License v3.0',
      spdx_id: 'AGPL-3.0',
      url: 'https://api.github.com/licenses/agpl-3.0',
      node_id: 'MDc6TGljZW5zZTE=',
    },
    allow_forking: true,
    is_template: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
]
